<template lang="pug">
.assign-item.d-flex
  v-avatar.ml-6.my-2.mr-4(color="neutral300" size="24")
    v-img(v-if="hasCompanyLogo" :src="company.logo.file" :alt="company.name")
    span.text-xs.font-semibold.neutral500--text(v-else) {{ company.name | initialCharacters }}
  
  .flex-grow-1.mt-2.mr-6
    .text-sm.font-semibold.mb-4 {{ $t('assign_team') }}
    div
      v-combobox.round-xl.mb-4.text-xs(v-model="assignees" outlined dense :items="items" multiple chip hide-details append-icon="$yzi-chevron-down" :menu-props="{ top: true, offsetY: true, rounded: 'lg', nudgeTop: 8, closeOnContentClick: true}")
        template(#selection="{ attrs, item, parent, selected }")
          v-chip.px-2.my-1(v-bind="attrs" color="neutral300" :input-value="selected" label small)
            span.pr-1.text-xs {{ item }}
            v-icon(@click="parent.selectItem(item)" size=14) mdi-close
        template(#item="{ index, item }")
          .text-sm {{ item }}

    .d-flex.justify-end.my-4
      v-btn.button-sm.underline.mr-4(text @click="$emit('leftBtnClicked')") {{ $t('cancel') }}
      v-btn.button-sm.neutral700--text(color="neutral300" :loading="rightBtnLoading" :disabled="assignees && assignees.length === 0" depressed @click="$emit('rightBtnClicked', assignees)") {{ $t('save') }}
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'AssignItem',
  props: {
    items: {
      type: Array,
      default: () => []
    },
    currentAssignees: {
      type: Array,
      default: null
    },
    rightBtnLoading: {
      type: Boolean,
      default: false
    },
    leftBtnLoading: {
      type: Boolean,
      default: false
    },
  },
  data () {
    return {
      isLoading: false,
      assignees: null,
    }
  },
  computed: {
    ...mapGetters({
      company: 'getCompany'
    }),
    hasCompanyLogo() {
      return this.company.logo?.file
    },
  },
  mounted () {
    if (this.currentAssignees) {
      this.assignees = this.currentAssignees
    }
  }
}
</script>